import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {
  constructor(
  ) { }
 
  
  treeSelect(source, pid: any = -1, parentKey?:any,type?:any) {
    let cloneData
    if(type===0)
      cloneData = JSON.parse(JSON.stringify(source));
    else
      cloneData = JSON.parse(JSON.stringify(source)).filter((father) => +father.status === 1);
    cloneData.forEach(element => {
      element.label = element.name;
      element.value = element.id;
      element.title = element.name;
      element.key = element.id;
    });
    const tree = this.buildTreeNode(cloneData, pid, 'id', parentKey, 'children');
    this.treeDataSorting(tree);
    this.treeDataIsLeaf(tree);
    return tree;
  }

  /**
   * 生成树形节点
   * 调用时，字段名以字符串的形式传参，如treeData(source, -1, 'id' 'parentId', 'children')
   * @param source  原始数据
   * @param rootNodeId 顶级节点id
   * @param id 'id'
   * @param parentId 'pid'
   * @param children 'children'
   */
   buildTreeNode(source, rootNodeId, id = 'id', parentId = 'pid', children = 'children') {
    const cloneData = JSON.parse(JSON.stringify(source));
    return cloneData.filter((father) => {
      const branchArr = cloneData.filter((child) => father[id] === child[parentId]);
      branchArr.length > 0 ? father[children] = branchArr : father[children] = [];
      return father[parentId] === rootNodeId;
    });
  }

  
  /**
   * 叶子节点排序
   * @param source 树形数据
   */
   treeDataSorting(source) {
    source.sort((a, b) => {
      return a.sort - b.sort;
    });
    source.forEach(element => {
      element.children.sort((a, b) => {
        return a.sort - b.sort;
      });
      if (element.children && element.children.length > 0) {
        this.treeDataSorting(element.children); // 子级递归
      }
    });
  }

  /**
   * 遍历整棵大树 标记叶子节点
   * @param source 树形数据
   */
   treeDataIsLeaf(source, level = 0) {
    level++;
    source.forEach(element => {
      element.level = level;
      if (element.children && element.children.length > 0) {
        element.isLeaf = false;
        this.treeDataIsLeaf(element.children, level);       // 子级递归
      } else {
        element.isLeaf = true;
        return;
      }
    });
  }
   /**
   * 通叶子节点id找 分类路径  返回的是 id 数组
   * @param id
   * @param arr
   * @param ids
   * @returns
   */
    getClassificationPathElderIdByClassificationId(id, arr, ids) {
      const _ids = ids;
      let parent: number;
      arr.forEach(i => {
        if (i.id === +id) {
          parent = i.pid;
          _ids.unshift(+id);
        }
      });
      if (parent === -1 || !id) {
        return _ids;
      } else {
        return this.getClassificationPathElderIdByClassificationId(parent, arr, _ids);
      }
    }

    
  getJSONParse = (data, returnData?) => {
    try {
      if (data) {
        return JSON.parse(data);
      } else {
        return returnData ? returnData : data;
      }
    } catch (e) {
      return returnData ? returnData : data;
    }
  }
}